import { render, staticRenderFns } from "./Website.vue?vue&type=template&id=6f954c14&scoped=true&"
import script from "./Website.vue?vue&type=script&lang=ts&"
export * from "./Website.vue?vue&type=script&lang=ts&"
import style0 from "./Website.vue?vue&type=style&index=0&id=6f954c14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f954c14",
  null
  
)

export default component.exports